import {Component, OnInit} from '@angular/core';
import {FinancialManagementService} from '../../../../pages/financial/_services/financial-management.service';
import {FinancialSetting} from '../../../../pages/financial/_models/financial-management.model';
import {FormControl, FormGroup} from '@angular/forms';

@Component({
  selector: 'acabim-admin-onboarding-financial-dates',
  templateUrl: './onboarding-financial-dates.component.html',
  styleUrls: ['../styles.scss', './onboarding-financial-dates.component.scss']
})
export class OnboardingFinancialDatesComponent implements OnInit {

  isLoading = false;
  periods: { name: string }[] = [];
  intervalTypes: { name: string, id: string }[] = [];
  financialForm = new FormGroup({
    period: new FormControl(null),
    startDate: new FormControl(null),
    interval: new FormControl(null),
    intervalValue: new FormControl(null),
  });

  constructor(
      private readonly financialService: FinancialManagementService,

  ) { }

  ngOnInit(): void {
    this.getPreferences();
  }

  getPreferences(): void {
    this.isLoading = true;
    this.financialService.getFinancialPeriods().subscribe(periodData => {
      this.periods = [];
      periodData.forEach(str => {
        this.periods.push({name: str});
      });
      this.financialService.getInterval().subscribe(data => {
        this.intervalTypes = [];
        this.intervalTypes.push({name: data.currentMonth, id: 'currentMonth'});
        this.intervalTypes.push({name: data.daysAfter, id: 'daysAfter'});
        this.intervalTypes.push({name: data.daysAfterMonth, id: 'daysAfterMonth'});
        this.intervalTypes.push({name: data.followingMonth, id: 'followingMonth'});
        this.financialService.getCurrentSettings().subscribe(currentSettingData => {
          this.isLoading = false;
          console.dir(currentSettingData);
          if (this.financialForm && currentSettingData) {
            const startDate: string | null = currentSettingData.reporting_period_start_date ? currentSettingData.reporting_period_start_date.toString() : null;
            const period = this.periods.filter(x => x.name === currentSettingData.reporting_period)[0];
            this.financialForm.get('period')?.setValue(period);
            this.financialForm.get('startDate')?.setValue(startDate ? new Date(startDate) : null);
            const interval = this.intervalTypes.filter(x => x.id === currentSettingData.default_payment_period_interval)[0];
            this.financialForm.get('interval')?.setValue(interval);
            this.financialForm.get('intervalValue')?.setValue(currentSettingData.default_payment_period_value);
          }
        });
      });
    });
  }

  submit(value: boolean) {
    const payload = this.gather();
    this.isLoading = true;
    this.financialService.setCurrentSettings(payload).subscribe(res => {
      this.getPreferences();
    });
  }

  gather(): FinancialSetting {
    return {
      default_payment_period_interval: this.financialForm.get('interval')?.value?.id,
      default_payment_period_value: this.financialForm.get('intervalValue')?.value,
      reporting_period_start_date: this.financialForm.get('startDate')?.value,
      reporting_period: this.financialForm.get('period')?.value?.name,
    };
  }

} // EOC
